import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerticalBarsStacked100 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M59.075 227.105h42.553v-48.632H59.075z"
      clipRule="evenodd"
    />
    <path
      fill="#F6F6F9"
      fillRule="evenodd"
      d="M59.075 121.125h42.542V34.556c0-6.714-5.443-12.158-12.158-12.158H71.233c-6.715 0-12.158 5.444-12.158 12.158z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M59.075 178.473h42.542v-62.826H59.075zM125.95 148.046h42.542v-53.85H125.95z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M125.95 227.104h42.553v-85.106H125.95z"
      clipRule="evenodd"
    />
    <path
      fill="#F6F6F9"
      fillRule="evenodd"
      d="M125.95 94.195h42.542V34.552c0-6.715-5.443-12.158-12.158-12.158h-18.226c-6.714 0-12.158 5.443-12.158 12.158z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M192.825 157.021h42.542V85.22h-42.542z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M192.825 227.103h42.553v-72.948h-42.553z"
      clipRule="evenodd"
    />
    <path
      fill="#F6F6F9"
      fillRule="evenodd"
      d="M192.825 85.22h42.542V34.552c0-6.715-5.443-12.158-12.158-12.158h-18.226c-6.714 0-12.158 5.443-12.158 12.158z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVerticalBarsStacked100;
